<agpr-dialog-container
    [id]="'createEditSourceGroupDialog'"
    class="agpr-createEditSourceGroupDialog"
    [heading]="editing ? 'SourceGroup.editDialog.heading' : 'SourceGroup.createDialog.heading'"
    (close)="cancel()"
>
    <div class="agpr-createEditSourceGroupDialog-content">
        <agpr-scroll-panel>
            <div class="agpr-createEditSourceGroupDialog-name">
                <agpr-text-input
                    [id]="'createEditSourceGroupDialog_name'"
                    label="SourceGroups.createDialog.name"
                    placeholder="SourceGroups.createDialog.name.placeholder"
                    [(ngModel)]="group.name"
                    (ngModelChange)="validateGroupName()"
                    [ariaInvalid]="groupNameErrors.length > 0"
                ></agpr-text-input>
                <agpr-form-message
                    *ngFor="let error of groupNameErrors"
                >{{ error | localize }}</agpr-form-message>
            </div>
            <div class="agpr-createEditSourceGroupDialog-existingSources">
                <agpr-panel
                    *ngIf="group.sourceIds"
                    [marginTop]="0"
                    header="SourceGroup.sources"
                    [collapsed]="existingSourcesCollapsed"
                >
                    <div class="agpr-createEditSourceGroupDialog-existingSources-chips">
                        <agpr-scroll-panel>
                            <ul>
                                <li
                                    *ngFor="let chip of sourceChips; let i = index"
                                    [id]="'createEditSourceGroupDialog_existingSources_chip_' + i"
                                    class="agpr-chip"
                                    [attr.aria-label]="chip.label"
                                >
                                    <span
                                        class="agpr-chip-label"
                                    >
                                        {{ chip.label }}
                                    </span>
                                    <span
                                        class="agpr-chip-type"
                                    >
                                        {{ chip.type }}
                                    </span>
                                    <button
                                        [id]="'createEditSourceGroupDialog_existingSources_chip_' + i + '_delete'"
                                        class="agpr-chip-icon agpr-i-close"
                                        agprTooltip="Common.forms.chips.delete"
                                        [useTooltipAsAriaLabel]="false"
                                        tooltipPosition="top"
                                        (click)="removeExistingSource(chip)"
                                        [attr.aria-label]="chip.label + ' ' + ('Common.forms.chips.delete' | localize)"
                                    ></button>
                                </li>
                            </ul>
                        </agpr-scroll-panel>
                    </div>
                </agpr-panel>
            </div>

            <div class="agpr-createEditSourceGroupDialog-newSources">
                <agpr-search-source-picker
                    [id]="'createEditSourceGroupDialog_sources'"
                    [(ngModel)]="sourceIds"
                ></agpr-search-source-picker>
            </div>
        </agpr-scroll-panel>
    </div>
    <ng-template #footerLeft>
        <agpr-button
            [id]="'createEditSourceGroupDialog_cancel'"
            label="cancel"
            (click)="cancel()"
        ></agpr-button>
    </ng-template>
    <ng-template #footerRight>
        <agpr-button
            [id]="'createEditSourceGroupDialog_ok'"
            [style]="buttonTypes.primary"
            [disabled]="!group.name || groupNameErrors.length > 0"
            [label]="editing ? 'save' : 'create'"
            (click)="confirm()"
        ></agpr-button>
    </ng-template>
</agpr-dialog-container>